import '@mrhenry/wp--bugsnag-config';

/* Modules */
import './modules/mr-carousel.ts';

import { PrivacyControls, initMenuButtons } from '@mrhenry/wp--mr-interactive';

PrivacyControls.setupPrivacyAwareEmbedders();

requestAnimationFrame( () => {
	initMenuButtons();
} );
